export type DailySpendStatus = 'green' | 'yellow' | 'red' | 'unset';

export const YELLOW_OVER_RATIO = 1.2;

export function spendStatus(spend: number, budget: number | null | undefined): DailySpendStatus {
  if (budget == null || budget <= 0) return 'unset';
  if (spend <= budget) return 'green';
  if (spend <= budget * YELLOW_OVER_RATIO) return 'yellow';
  return 'red';
}

export function spendPct(spend: number, budget: number | null | undefined): number | null {
  if (budget == null || budget <= 0) return null;
  return Math.round((spend / budget) * 1000) / 10;
}

export function statusLabel(status: DailySpendStatus): string {
  if (status === 'green') return 'On track';
  if (status === 'yellow') return 'Over budget';
  if (status === 'red') return 'Well over';
  return 'Not set';
}
